// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mc-login-form[data-v-e628a06e] {\n  margin: 0px auto;\n  width: 500px;\n  min-height: 350px;\n  border: 1px solid #e8e8e8;\n  background-color: #fbfbfb;\n  border-radius: 3px;\n  padding: 20px 30px;\n}\n.ant-tabs-bar[data-v-e628a06e] {\n  border: none !important;\n}\n.ant-tabs-top-bar[data-v-e628a06e] {\n  text-align: center;\n}\n.ant-tabs-tab[data-v-e628a06e] {\n  margin: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
